import {
  ETransactionErrorMessages,
  ETransactionErrorState,
} from "../../../hooks/useTransactionErrorHandler";
import { ErrorHandler } from "../ErrorHandler.abstract.class";

export class GenericErrorHandler extends ErrorHandler {
  code?: number;
  public ERROR_MESSAGES: Record<ETransactionErrorState, Record<number, string[]>> = {
    BUILD: {
      10: [ETransactionErrorMessages.INPUTS_EXHAUSTED, ETransactionErrorMessages.NOT_ENOUGH_ADA],
      11: [ETransactionErrorMessages.MISSING_INPUT_OUTPUT],
      12: [ETransactionErrorMessages.NO_COLLATERAL_UTXOS],
      13: [ETransactionErrorMessages.TOO_MANY_INPUTS],
      14: [
        ETransactionErrorMessages.UTXO_ALREADY_SPENT_1,
        ETransactionErrorMessages.UTXO_ALREADY_SPENT_2,
      ],
      20: [ETransactionErrorMessages.RESERVE_ALREADY_LOCKED],
      21: [
        ETransactionErrorMessages.RESERVE_INSERT_FAIL,
        ETransactionErrorMessages.RESERVE_UPDATE_FAIL,
      ],
      23: [ETransactionErrorMessages.RESERVE_WITHDRAW_FAIL],
    },
    SEND: {},
    SIGN: {
      3: [ETransactionErrorMessages.FEE_EXCEEDS_MAXIMUM],
    },
  };

  constructor(
    error: ETransactionErrorMessages | string,
    private transactionState: ETransactionErrorState
  ) {
    super();

    this.code = this.getKey(error);
  }

  shouldReport(): boolean {
    return true;
  }

  getCode(): number | undefined {
    return this.code;
  }

  private getKey(value: ETransactionErrorMessages | string): number | undefined {
    let matchedKey: string | undefined = undefined;

    Object.entries(this.ERROR_MESSAGES[this.transactionState]).forEach(([key, messageValues]) => {
      messageValues.forEach((val) => {
        if (value.includes(val) && !matchedKey) {
          matchedKey = key;
        }
      });
    });

    return matchedKey && Number(matchedKey);
  }
}
